import styled from "styled-components";
import { SkeletonBase } from "../../shared/OwSkeleton/OwSkeleton";

const SkeletonCard = styled.div`
    border: 1px solid var(--minor-bg-color);
    border-radius: 0.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 25rem;
`;

const SkeletonImage = styled(SkeletonBase)`
    height: 180px;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
`;

const SkeletonContent = styled.div`
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

const SkeletonQtyRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.25rem;
    margin-top: 0.5rem;
`;

const SkeletonButton = styled(SkeletonBase)`
    height: 38px;
    width: 38px;
`;

const SkeletonInput = styled(SkeletonBase)`
    height: 38px;
    width: 60px;
`;

const SkeletonAddButton = styled(SkeletonBase)`
    height: 38px;
    width: 120px;
    margin: 0.5rem auto;
`;

const SkeletonPrice = styled(SkeletonBase)`
    height: 2rem;
    width: 80px;
`;

const SkeletonName = styled(SkeletonBase)`
    height: 1.2rem;
    width: 90%;
`;

const SkeletonSku = styled(SkeletonBase)`
    height: 0.9rem;
    width: 60%;
`;

const SkeletonDescription = styled(SkeletonBase)`
    height: 3rem;
    width: 100%;
`;

const SkeletonCategory = styled(SkeletonBase)`
    height: 1rem;
    width: 40%;
    margin-top: auto;
`;

export const EcommerceListViewSkeleton: React.FC = () => {
    return (
        <div className="col">
            <SkeletonCard>
                <SkeletonImage />
                <SkeletonContent>
                    <SkeletonQtyRow>
                        <SkeletonButton />
                        <SkeletonInput />
                        <SkeletonButton />
                    </SkeletonQtyRow>
                    <SkeletonAddButton />
                    <SkeletonPrice />
                    <SkeletonName />
                    <SkeletonSku />
                    <SkeletonDescription />
                    <SkeletonCategory />
                </SkeletonContent>
            </SkeletonCard>
        </div>
    );
};
